import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useLeftNavigationContext } from 'features/left_navigation/left_navigation_context'

import { leftNavigationSelector } from '../selectors'

/**
 * @returns {'phone-expanded' | 'phone-collapsed' | 'default' | 'minimized' | 'expanded'}
 */
export const useLeftNavigationState = () => {
  const isPhone = useDeviceType('isPhone')
  const isTabletDown = useDeviceType('isTabletDown')
  const { fixed, open } = useSelector(leftNavigationSelector)
  const { isCustomSideNav } = useLeftNavigationContext()

  return useMemo(() => {
    if (isPhone) {
      return open ? 'phone-expanded' : 'phone-collapsed'
    }

    if (isCustomSideNav) {
      return 'default'
    }

    if (isTabletDown || !fixed) {
      return open ? 'expanded' : 'minimized'
    }

    return 'default'
  }, [isPhone, isCustomSideNav, isTabletDown, fixed, open])
}
